export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              合作交流
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              如果你有影视资源投稿需求，或希望对平台内容提出建议，欢迎通过以下方式联系我们。嫩草视频始终以开放的态度欢迎每一位热爱影视的朋友。
            </p>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 flex-shrink-0">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">投稿邮箱</div>
                  <span className="text-sm text-foreground-500">tougao@nencao-video.com</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 flex-shrink-0">
                  <i className="ri-message-2-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">意见反馈</div>
                  <span className="text-sm text-foreground-500">fankui@nencao-video.com</span>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 flex-shrink-0">
                  <i className="ri-shake-hands-line text-secondary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">商务合作</div>
                  <span className="text-sm text-foreground-500">hezuo@nencao-video.com</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/80">
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                快速反馈
              </h3>
              <p className="text-sm text-foreground-500 mb-5">
                告诉我们你想看什么内容，我们将尽力满足你的观影需求。
              </p>
              <div className="space-y-4">
                <div>
                  <input
                    type="text"
                    placeholder="你的昵称"
                    className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-sm text-foreground-700 placeholder-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
                <div>
                  <textarea
                    rows={3}
                    placeholder="写下你想看的内容或建议..."
                    className="w-full px-4 py-3 rounded-xl border border-background-200 bg-background-50 text-sm text-foreground-700 placeholder-foreground-300 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                  ></textarea>
                </div>
                <button
                  type="button"
                  className="w-full py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交反馈
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}